<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #scrollableContent>
    <app-messages-container
      [senders]="senders"
      [selectedSenderId]="selectedSenderId"
      [recipientInfo]="recipient"
      [messages]="messages$ | async"
      [messageState]="messageState$ | async"
      [isProfileConnecting]="isProfileConnecting$ | async"
      (onSenderSelect)="onSenderSelect($event)"
      (onSendMessage)="onSendMessage($event)"
      (onConnectProfile)="onConnectProfile()"></app-messages-container>
  </ng-template>
</app-modal>
